











































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbContainer, mdbRow, mdbCol, mdbInput, mdbSelect, mdbBtn, mdbIcon, mdbAlert, mdbProgress } from '@folky-tools/mdbvue';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessProspectConfiguration } from '@/models/prospects/business-prospect-configuration';
import { BusinessProspect } from '@/models/prospects/business-prospect';
import { UserPermissionAction, UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { BusinessProspectType } from '@/models/prospects/business-prospect-type';
import { authenticationService, prospectsService, appService, businessesService, authorizationManagerService, usersService } from '@/services';
import { is_email_valid as isEmailValid } from 'node-email-validation';
import { required, email } from 'vuelidate/lib/validators';
import { redsys } from '@/plugins/redsys';

@Component({
    components: { mdbContainer, mdbRow, mdbCol, mdbInput, mdbSelect, mdbBtn, mdbIcon, mdbAlert, mdbProgress },
    validations: {
        businessProspect: {
            businessTradeName: { required },
            userEmail: {
                required,
                email,
                customEmail: async (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return isEmailValid(value);
                }
            },
            userPhone: {
                required,
                customPhone: async (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return /^\d{9}$/.test(value);
                }
            },
            tosAccepted: { requireChecked: (value, parentVm) => value === true }
        }
    }
})
export default class NewBusinessProspectView extends Vue {
    private isCurrentUserAuthenticated: boolean = false;
    private businessProspectConfig: BusinessProspectConfiguration = new BusinessProspectConfiguration();
    private businessProspect: BusinessProspect = new BusinessProspect({ userEmail: '' });
    private aErrorOccurred: boolean = false;
    private genericError?: string;
    private updateGenericErrorNotificationTimer?: NodeJS.Timeout;
    private showPageBlocker: boolean = true;
    private payingBusiness: boolean = false;
    private paidSuccessfully: boolean = false;
    private sendingBusiness: boolean = false;
    private sentSuccessfully: boolean = false;

    private get accountRequestTypeInfo(): boolean {
        return this.businessProspectConfig.type === BusinessProspectType.RequestInfo;
    }

    private async beforeMount(): Promise<void> {
        this.businessProspectConfig = await prospectsService.getBusinessProspectConfiguration();
        this.businessProspect.projectId = this.businessProspectConfig.projectId;
        this.businessProspect.pricingId = this.businessProspectConfig.pricingId;
        this.isCurrentUserAuthenticated = await authenticationService.isAuthenticated;

        if (this.$route.query && this.$route.query.businessProspectId && this.$route.query.paymentResult) {
            this.showPageBlocker = true;

            try {
                this.businessProspect = await prospectsService.getBusinessProspect(+this.$route.query.businessProspectId);

                if (this.$route.query.paymentResult === 'success') {
                    const merchantParams = this.$route.query.Ds_MerchantParameters || this.$route.query.DS_MERCHANTPARAMETERS;
                    const signature = this.$route.query.Ds_Signature || this.$route.query.DS_SIGNATURE;

                    if (merchantParams && signature) {
                        const merchantParamsDecoded = redsys.decodeMerchantParameters(merchantParams.toString());
                        const merchantSignatureNotif = redsys.createMerchantSignatureNotif(`${process.env.VUE_APP_FOLKY_TOOLS_REDSYS_PASSWORD}`, merchantParams.toString());
                        const dsResponse = parseInt(merchantParamsDecoded.Ds_Response || merchantParamsDecoded.DS_RESPONSE, 10);

                        if (redsys.merchantSignatureIsValid(signature.toString(), merchantSignatureNotif.toString()) && dsResponse > -1 && dsResponse < 100) {
                            if (this.isCurrentUserAuthenticated && this.businessProspect.userEmail === (await authenticationService.user)!.profile.email) {
                                if (await prospectsService.updateBusinessProspectPaymentStatusToPaidCorrectly(this.businessProspect)) {
                                    const newBusinessResponse = await await businessesService.newBusinessThroughProspect(+this.$route.query.businessProspectId);
                                    if (newBusinessResponse.result) {
                                        const business = await businessesService.getBusiness(newBusinessResponse.id);
                                        authorizationManagerService.addOrUpdatePermission(UserPermissionAction.Owner, UserEntityPermissionsType.Businesses, business.id);
                                        this.$router.push(`/businesses/dashboard/${business.id}?businessName=${encodeURIComponent(business.tradeName!)}`);
                                        return;
                                    }
                                }
                            } else {
                                if (await prospectsService.updateBusinessProspectPaymentStatusToPaidCorrectly(this.businessProspect, true)) {
                                    this.paidSuccessfully = true;
                                    return;
                                }
                            }

                            this.showGenericErrorWarning(this.$t('common.validation.standardErrorMsg').toString());
                            this.businessProspect.reset();
                            return;
                        }
                    }
                }

                this.showGenericErrorWarning(this.$t('views.prospects.newBusinessProspectView.notifications.payment.errorMessage').toString());
                await prospectsService.updateBusinessProspectPaymentStatusToPaymentError(+this.$route.query.businessProspectId);
                this.businessProspect.reset();
            } catch {
                this.showGenericErrorWarning(this.$t('common.validation.standardErrorMsg').toString());
                this.businessProspect.reset();
            } finally {
                this.showPageBlocker = false;
            }
        } else {
            this.showPageBlocker = false;
            if (this.isCurrentUserAuthenticated) {
                this.businessProspect.userEmail = (await authenticationService.user)!.profile.email;
            }
        }
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('changeNavbarClasses', '');
        this.$root.$emit('change-active-page', 'views.prospects.newBusinessProspectView.title');

        if (await authenticationService.isAuthenticated) {
            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasVisited,
                    entity: UserActionEntityType.BusinessProspects,
                    scope: UserActionScopeType.New
                })
            );
        }
    }

    private async pay(): Promise<void> {
        this.payingBusiness = true;

        this.$v.businessProspect.$touch();
        if (this.$v.businessProspect.$error) {
            this.payingBusiness = false;
            return;
        }

        try {
            const actualApp = appService.getCurrentApplication();
            if (!this.isCurrentUserAuthenticated && (await usersService.existsUserByEmail(this.businessProspect.userEmail!))) {
                this.showGenericErrorWarning(this.$t('views.prospects.newBusinessProspectView.notifications.existingEmail.pleaseLogin').toString());
                return;
            }

            this.businessProspect.paymentOrderId = redsys.getRandomOrderId();
            this.businessProspect.userNotificationLanguageCulture = this.$i18n.locale;
            const saveBusinessProspectResponse = await prospectsService.newBusinessProspect(this.businessProspect);

            if (saveBusinessProspectResponse.result) {
                if (await authenticationService.isAuthenticated) {
                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasCreated,
                            entity: UserActionEntityType.BusinessProspects,
                            scope: UserActionScopeType.New,
                            entityId: saveBusinessProspectResponse.id
                        })
                    );
                }

                const redsysData: any = {
                    DS_MERCHANT_AMOUNT: this.businessProspectConfig.priceToCharge,
                    DS_MERCHANT_ORDER: this.businessProspect.paymentOrderId,
                    DS_MERCHANT_MERCHANTCODE: `${process.env.VUE_APP_FOLKY_TOOLS_REDSYS_MERCHANT_CODE}`,
                    DS_MERCHANT_CURRENCY: '978',
                    DS_MERCHANT_TRANSACTIONTYPE: '0',
                    DS_MERCHANT_TERMINAL: '001',
                    DS_MERCHANT_CONSUMERLANGUAGE: this.$i18n.locale === 'es-ES' ? '001' : this.$i18n.locale === 'eu-ES' ? '013' : '010',
                    DS_MERCHANT_PAYMETHODS: 'C',
                    DS_MERCHANT_MERCHANTURL: actualApp.clientUri,
                    DS_MERCHANT_URLOK: actualApp.clientUri + this.$router.resolve({ name: 'newBusinessProspect' }).href + `?businessProspectId=${saveBusinessProspectResponse.id}&paymentResult=success`,
                    DS_MERCHANT_URLKO: actualApp.clientUri + this.$router.resolve({ name: 'newBusinessProspect' }).href + `?businessProspectId=${saveBusinessProspectResponse.id}&paymentResult=error`
                };

                const redsysForm = document.createElement('form');
                redsysForm.setAttribute('action', `${process.env.VUE_APP_FOLKY_TOOLS_REDSYS_PAY_URL}`);
                redsysForm.setAttribute('method', 'POST');
                redsysForm.setAttribute('style', 'display: none');

                const fieldSignatureVersion = document.createElement('input');
                fieldSignatureVersion.setAttribute('type', 'hidden');
                fieldSignatureVersion.setAttribute('name', 'Ds_SignatureVersion');
                fieldSignatureVersion.setAttribute('value', 'HMAC_SHA256_V1');
                redsysForm.appendChild(fieldSignatureVersion);

                const fieldParameters = document.createElement('input');
                fieldParameters.setAttribute('type', 'hidden');
                fieldParameters.setAttribute('name', 'Ds_MerchantParameters');
                fieldParameters.setAttribute('value', redsys.createMerchantParameters(redsysData));
                redsysForm.appendChild(fieldParameters);

                const fieldSignature = document.createElement('input');
                fieldSignature.setAttribute('type', 'hidden');
                fieldSignature.setAttribute('name', 'Ds_Signature');
                fieldSignature.setAttribute('value', redsys.createMerchantSignature(`${process.env.VUE_APP_FOLKY_TOOLS_REDSYS_PASSWORD}`, redsysData));
                redsysForm.appendChild(fieldSignature);

                document.body.appendChild(redsysForm);
                redsysForm.submit();
            } else {
                this.showGenericErrorWarning(this.$t('common.validation.standardErrorMsg').toString());
            }
        } catch {
            this.showGenericErrorWarning(this.$t('common.validation.standardErrorMsg').toString());
        } finally {
            this.payingBusiness = false;
        }
    }

    private async send(): Promise<void> {
        this.sendingBusiness = true;

        this.$v.businessProspect.$touch();
        if (this.$v.businessProspect.$error) {
            this.sendingBusiness = false;
            return;
        }

        try {
            this.businessProspect.userNotificationLanguageCulture = this.$i18n.locale;
            const saveBusinessProspectResponse = await prospectsService.newBusinessProspect(this.businessProspect);

            if (saveBusinessProspectResponse.result) {
                this.sentSuccessfully = true;
                if (await authenticationService.isAuthenticated) {
                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasCreated,
                            entity: UserActionEntityType.BusinessProspects,
                            scope: UserActionScopeType.New,
                            entityId: saveBusinessProspectResponse.id
                        })
                    );
                }
            } else {
                this.showGenericErrorWarning(this.$t('common.validation.standardErrorMsg').toString());
            }
        } catch {
            this.showGenericErrorWarning(this.$t('common.validation.standardErrorMsg').toString());
        } finally {
            this.sendingBusiness = false;
        }
    }

    private showGenericErrorWarning(error: string): void {
        this.aErrorOccurred = true;
        this.genericError = error;
        this.updateGenericErrorNotificationTimer = setInterval(this.hideGenericErrorWarning, 1000 * 10);
    }

    private hideGenericErrorWarning(): void {
        this.aErrorOccurred = false;
        this.genericError = undefined;
        clearInterval(this.updateGenericErrorNotificationTimer!);
    }
}
